import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExhibitionLayoutLayer from "../components/ExhibitionLayoutLayer";

const ExhibitionLayoutPage = () => {
    return (
        <MasterLayout>
            <ExhibitionLayoutLayer />
        </MasterLayout>
    );
};

export default ExhibitionLayoutPage;
